import api from '../services/api';

export interface LoginResponse {
  user: {
    id: number;
    name: string;
    email: string;
    role: 'admin' | 'coordinator';
    center: string;
    staff_status: 'active' | 'inactive';
  };
  token: string;
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const { data } = await api.post<LoginResponse>('/login', { email, password });
    return data;
  },

  async logout(): Promise<void> {
    await api.post('/logout');
  },

  async me() {
    const { data } = await api.get('/me');
    return data;
  },

  async updateProfile(payload: { name?: string; email?: string }) {
    const { data } = await api.put('/profile', payload);
    return data;
  },

  async updatePassword(payload: { current_password: string; new_password: string }) {
    const { data } = await api.put('/password', payload);
    return data;
  },
};
